import React, { useEffect, useRef } from "react";
import { GoogleApiWrapper } from "google-maps-react";
import { TextField } from "@material-ui/core";

const MapContainer = (props) => {

    useEffect(() => {
        if (window.google) {
            var autoComplete = new window.google.maps.places.Autocomplete(
                document.getElementById("map-input"),
                {
                    types: ["geocode"],
                }
            );

            autoComplete.setFields(["address_components", "formatted_address"]);
            autoComplete.addListener("place_changed", () => {
                const mappedPlace = autoComplete.getPlace().address_components?.reduce(
                    (mappedPlace, item) => {
                        let addressType = item.types[0];
                        switch (addressType) {
                            case "street_number":
                                mappedPlace.streetNumber = item["short_name"];
                                mappedPlace.location += mappedPlace.streetNumber + " ";
                                break;
                            case "route":
                                mappedPlace.street = item["long_name"];
                                mappedPlace.location += mappedPlace.street + ", ";
                                break;
                            case "locality":
                                mappedPlace.city = item["long_name"];
                                mappedPlace.location += mappedPlace.city + ", ";
                                break;
                            case "administrative_area_level_1":
                                mappedPlace.stateCode.label = item["long_name"];
                                mappedPlace.stateCode.value = item["short_name"];
                                mappedPlace.location += mappedPlace.stateCode.value + " ";
                                break;
                            case "administrative_area_level_2":
                                mappedPlace.country = item["long_name"];
                                mappedPlace.location += mappedPlace.country;
                                break;
                            case "postal_code":
                                mappedPlace.zipCode = item["short_name"];
                                mappedPlace.location += mappedPlace.zipCode;
                                break;
                            default:
                                break;
                        }
                        return mappedPlace;
                    },
                    {
                        location: "",
                        streetNumber: "",
                        street: "",
                        city: "",
                        stateCode: { label: "", value: "" },
                        country: "",
                        zipCode: "",
                    }
                );

                props.onMapChanged({
                    ...mappedPlace,
                });
            });
        }
    }, []);

    return (
        <div>
            <TextField
                id="map-input"
                name={props.name}
                label={props.title}
                type="text"
                fullWidth
                value={props.value ?? ""}
                placeholder={props.placeholder || "Search address.."}
                onKeyUp={(e) => {
                    e.key === "Enter" && e.preventDefault();
                }}
                onChange={(e) => props.setGoogleAddress(e.target.value)}
            />
            {props.errors && props.errors[props.name] ? (
                <span className="error-message">{props.errors[props.name].message}</span>
            ) : null}
        </div>
    );
};

export default GoogleApiWrapper({
    apiKey: process.env.REACT_APP_GOOGLE_MAP_API_TOKEN || "",
})(MapContainer);
